import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/k6j5WxoZnJiMxFK6j4qarJ/ChatGPT_Image_13_sept_2026,_21_38_38-Photoroom.png';
const trustItems = ['Single payment', 'Instant access', 'Ready to print'];
const reassuranceItems = [{
  icon: DownloadIcon,
  label: 'Instant download'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}, {
  icon: ShieldCheckIcon,
  label: '30-day guarantee'
}];
export function HeroSection() {
  return <section id="top" aria-labelledby="hero-title" className="flex min-h-[calc(100svh-2.75rem)] w-full items-center bg-cream px-5 py-6 md:py-10 lg:py-14" data-id="element-112" data-mp="2msunycq4lwej">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto grid w-full max-w-content items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-113" data-mp="3fi1lb8dugfy7">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-114" data-mp="2fd5wbn3d59g5">
          <p className="text-[11px] font-bold uppercase leading-tight tracking-[0.12em] text-turquoise sm:text-[13px]" data-id="element-115" data-mp="2bbu55d4ucg5u">
            U8 · U10 · U12 · U14 · U17 — AGES 7 TO 17
          </p>

          <h1 id="hero-title" className="mt-3 font-display text-[clamp(1.65rem,6.4vw,2.375rem)] font-extrabold leading-[1.1] tracking-tight text-pine lg:mt-5 lg:text-[56px]" data-id="element-116" data-mp="2kdaf5jrqug9j">
            Coach an Entire
            <br data-id="element-117" data-mp="383xng65kn7wm" />
            <span className="italic text-amber" data-id="element-118" data-mp="384fve01ljakd">Lacrosse Season</span> in
            <br data-id="element-119" data-mp="3353515binld1" />
            Just 5 Minutes of
            <br data-id="element-120" data-mp="336e812x50p33" />
            Preparation
          </h1>

          <p className="mt-3.5 max-w-[480px] text-[14px] leading-[1.55] text-slate-body sm:text-base sm:leading-[1.6] lg:mt-6" data-id="element-121" data-mp="1dpwo7k640iw0">
            <strong className="font-bold text-ink" data-id="element-122" data-mp="18s4z0xwunavi">LACROSSE READY 360™</strong> is the complete, ready-to-use
            girls&apos; lacrosse curriculum. <strong className="font-bold text-ink" data-id="element-123" data-mp="38vfjooww1xvn">6 volumes</strong>,{' '}
            <strong className="font-bold text-ink" data-id="element-124" data-mp="3dsxw4pa46v8e">48 training blocks</strong> and{' '}
            <strong className="font-bold text-ink" data-id="element-125" data-mp="3iqpp7mmhwne6">180+ drills and games</strong>, already planned and sequenced —
            even if you have never played lacrosse in your life.
          </p>

          <img src={MOCKUP_SRC} alt="The six LACROSSE READY 360 volume covers fanned out with a tablet, coaching board and lacrosse equipment" className="my-5 max-h-[28svh] w-[88%] object-contain lg:hidden" data-id="element-126" data-mp="3rr5sow38nuj1" />

          <div className="flex w-full flex-col items-center lg:items-start" data-id="element-127" data-mp="abph0d6ru9hd">
            <CTAButton pinArrow className="h-16 w-full max-w-[460px] whitespace-normal text-sm shadow-lift sm:h-[68px] sm:text-base lg:mt-10" data-id="element-128" data-mp="ads52rod5sjg" />

            <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 lg:justify-start" data-id="element-129" data-mp="jcx6q6v821zu">
              {trustItems.map(item => <li key={item} className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-pine sm:text-[13px]" data-id="element-130" data-mp="1yutm4tm5f49b">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-turquoise" strokeWidth={3} aria-hidden="true" data-id="element-131" data-mp="1uujb32ji1nnl" />
                  {item}
                </li>)}
            </ul>

            <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 lg:justify-start" data-id="element-132" data-mp="2mjmd0bnwylx2">
              {reassuranceItems.map(({
              icon: ItemIcon,
              label
            }, index) => <li key={label} className="inline-flex items-center gap-2 text-xs text-slate-body" data-id="element-133" data-mp="2drkfal58bjqh" data-mpi={index}>
                  {index > 0 && <span aria-hidden="true" className="text-[#C9C2B2]" data-id="element-134" data-mp="28reunoxdmxhw">
                      ·
                    </span>}
                  <ItemIcon className="h-3.5 w-3.5 shrink-0 text-turquoise" strokeWidth={1.75} aria-hidden="true" data-id="element-135" data-mp="31hn2amuadzi8" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <img src={MOCKUP_SRC} alt="" aria-hidden="true" className="hidden w-full object-contain lg:block" data-id="element-136" data-mp="2q2toaxt6it59" />
      </motion.div>
    </section>;
}